import { render, staticRenderFns } from "./OrganizationList.vue?vue&type=template&id=7a55136c"
import script from "./OrganizationList.vue?vue&type=script&lang=js"
export * from "./OrganizationList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports